var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "text-info text-center text-sm-left"
  }, [_vm._v("Highlights")]), _vm.cycle === 1 ? [_vm.edTPAFact ? _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_vm._m(0), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.edTPAFact.MeetsCount / _vm.edTPAFact.PossibleCount)) + " edTPA Pass Rate ")]), _vm._v(" The percentage of candidates in IL who passed the edTPA exam on the first attempt, second, and third or more attempts. ")])]) : _vm._e()] : _vm.cycle === 4 ? [_vm._m(1), _vm._m(2)] : _vm.cycle === 5 ? [_vm._m(3), _vm._m(4)] : _vm.cycle === 6 ? [_vm._m(5), _vm._m(6)] : _vm._e(), _vm.cycle < 8 ? [_c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center pt-4 pt-sm-0"
  }, [_vm._m(7), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.placementFact.MeetsCount / _vm.placementFact.PossibleCount)) + " Placement Rate ")]), _vm._v(" The percentage of completers who begin working as a full-time teacher within two years of program completion in an Illinois public school"), _vm.cycle !== 1 ? _c('span', [_vm._v(", non-public school, or early learning setting")]) : _vm._e(), _vm._v(". ")])]), _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center pt-4 pt-sm-0"
  }, [_vm._m(8), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm.cycle === 5 ? _c('span', [_vm._v(" 69% ")]) : _vm.cycle === 6 ? _c('span', [_vm._v(" 71% ")]) : _c('span', [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.persistanceFact.MeetsCount / _vm.persistanceFact.PossibleCount)) + " ")]), _vm._v(" Retention Rate ")]), _vm._v(" The percentage of completers who continue working in an Illinois public school for 3 or more consecutive years. ")])])] : _vm._e(), _vm.cycle === 5 ? _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_vm._m(9), _vm._m(10)]) : _vm._e(), _vm.cycle === 6 ? _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_vm._m(11), _vm._m(12)]) : _vm._e(), _vm.cycle === 6 ? _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_vm._m(13), _vm._m(14)]) : _vm._e(), _vm.cycle === 8 ? [_vm._m(15), _vm._m(16), _vm._m(17), _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center pt-4 pt-sm-0"
  }, [_vm._m(18), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.placementFact.MeetsCount / _vm.placementFact.PossibleCount)) + " Placement Rate ")]), _vm._v(" A high percentage of completers begin working as a full-time teacher within two years of program completion in an Illinois public school, non-public school, or early learning setting. ")])]), _vm._m(19)] : _vm.cycle === 9 ? [_vm._m(20), _vm._m(21), _vm._m(22)] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" 3% Increase in Diverse Candidate Enrollment ")]), _vm._v(" Statewide diverse candidate enrollment increased in 2021 compared to 2020. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Increased Placement Rate ")]), _vm._v(" 40% of Programs earned higher scores in the Placement in Teaching Indicator in 2021 than in 2020. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" 6% Increase in Diverse Candidate Enrollment ")]), _vm._v(" Statewide diverse candidate enrollment increased in 2022 IEPP compared to 2021. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Diverse Candidate Enrollment is Trending Upwards ")]), _vm._v(" Diverse candidate enrollment has increased each of the last three years. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" 2% Increase in Diverse Candidate Enrollment ")]), _vm._v(" Statewide diverse candidate enrollment increased in 2023 IEPP compared to 2022. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Diverse Candidate Enrollment is Trending Upwards ")]), _vm._v(" Diverse candidate enrollment has increased each of the last four years. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-briefcase"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-chalkboard-teacher"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Teacher Retention is Trending Upward ")]), _vm._v(" Teacher persistence has increased each of the last three years. ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Teacher Retention is Trending Upward ")]), _vm._v(" Teacher persistence has increased each of the last three years. ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-bullseye"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Teacher Retention Remains Above State Target ")]), _vm._v(" The statewide Persistence in Teaching score has remained above the state target for the past two years. ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" 6% Increase in Diverse Candidate Enrollment ")]), _vm._v(" Statewide diverse candidate enrollment increased compared to 2023. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Diverse Candidate Enrollment is Trending Upwards ")]), _vm._v(" Diverse candidate enrollment has increased each of the last four years. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" More Diverse Completers ")]), _vm._v(" The number of diverse completers increased by 14% compared to 2023. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-briefcase"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Teacher Retention Remains Above State Target ")]), _vm._v(" The statewide Persistence in Teaching score has remained above the state target for the past three years. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" 3% Increase in Diverse Candidate Enrollment ")]), _vm._v(" Statewide diverse candidate enrollment increased in 2025 IEPP compared to 2024. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Diverse Candidate Enrollment is Trending Upwards ")]), _vm._v(" Diverse candidate enrollment has increased each of the last five years. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 d-flex justify-center h4 text-white m-0 section-icon mt-4 border-radius-100"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v(" Persistence in Teaching in High Needs Schools has Increased ")]), _vm._v(" The percentage of completers who began working as a full-time teacher within two years of program completion in an Illinois public school, non-public school, or early learning setting and remain in these positions has increased marginally since 2024. ")])]);
}];
export { render, staticRenderFns };